import React, { useEffect, useState } from 'react';

import icons, { IconName } from './icons';

interface IProps {
  name: IconName;
}

type IconProps = { draw: string; viewBox: string };

const Icon = ({ name }: IProps) => {
  const [icon, setIcon] = useState<IconProps>({ draw: '', viewBox: '' });

  useEffect(() => {
    setIcon(icons[name]);
  }, [name]);

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox={icon.viewBox}>
      <path
        clipRule="evenodd"
        d={icon.draw}
        fill="currentcolor"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default Icon;
